import { Box, Typography } from "@mui/material";
import { PREVIEW_WITNESSES } from "../utils/DefaultConfigWitness";
export const ConcatenatedPreview = ({ wrapperStart, wrapperEnd, separator }) => {
  const ws = wrapperStart || "";
  const we = wrapperEnd || "";
  const sep = separator || ",";

  const formatted = PREVIEW_WITNESSES.map(
    (w) => `${ws}${w.medio}${sep} ${w.autor}${we}`,
  ).join("  ");

  return (
    <Box
      sx={{
        backgroundColor: "#f0f4ff",
        border: "1px dashed #90caf9",
        borderRadius: "8px",
        p: 1,
        mt: 1,
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: "#1565c0", lineHeight: 1.8, wordBreak: "break-word" }}
      >
        {formatted}
      </Typography>
    </Box>
  );
};